import { RESPONSE, PURCHASE_INTENTS, ACCOUNT } from '~/constants'
import API from '~/apis/sbApi'
import { APP as URLS } from '~/constants/urls'
import history from '~/history'

export const getIntents = () => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.CLEAR_INTENTS })
    dispatch({ type: PURCHASE_INTENTS.CLEAR_VAT_PERCENT })
    const response = await new API().get(`${URLS.purchaseIntent}`)
    dispatch({
      type: PURCHASE_INTENTS.SET_INTENTS,
      intents: response.data?.intents,
    })
    dispatch({
      type: ACCOUNT.SET_INTENT_COUNT,
      count: response.data?.intents?.length,
    })
    dispatch({
      type: PURCHASE_INTENTS.SET_USER_ALLOWED_TO_PAY,
      allowed: response.data?.allowed_to_pay,
    })
    dispatch({
      type: PURCHASE_INTENTS.SET_VAT_PERCENT,
      vatPercent: response.data?.vat_percent,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const deleteIntent = (id) => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.CLEAR_INTENTS })
    await new API().delete(`${URLS.purchaseIntent}/${id}`)
    dispatch(getIntents())
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const deleteIntents = (afterDelete) => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.CLEAR_INTENTS })
    await new API().delete(`${URLS.purchaseIntents}`)
    dispatch({
      type: ACCOUNT.SET_INTENT_COUNT,
      count: 0,
    })
    afterDelete?.call()
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const saveIntent = (id, parameters) => async (dispatch) => {
  try {
    await new API().put(`${URLS.purchaseIntent}/${id}`, parameters)
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const startPayment = (onFailure, paymentMethod) => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.PAYING, value: true })
    const config = paymentMethod
      ? { params: { payment_method: paymentMethod } }
      : {}
    const response = await new API().get(`${URLS.startPayment}`, config)

    dispatch({ type: PURCHASE_INTENTS.PAYING, value: false })

    if (response.data?.url) {
      if (response.data.url.startsWith('http')) {
        window.location.href = response.data.url
      } else {
        history.push(response.data.url)
      }
    } else {
      onFailure?.call()
    }
  } catch (error) {
    dispatch({ type: PURCHASE_INTENTS.PAYING, value: false })
    dispatch({ type: RESPONSE.SET_ERROR, error })
    onFailure?.call()
  }
}

export const getOpenPayments = () => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.CLEAR_OPEN_PAYMENTS })
    const response = await new API().get(`${URLS.openPayments}`)
    dispatch({
      type: PURCHASE_INTENTS.SET_OPEN_PAYMENTS,
      openPayments: response.data,
    })
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}

export const cancelPayment = () => async (dispatch) => {
  try {
    dispatch({ type: PURCHASE_INTENTS.CLEAR_OPEN_PAYMENTS })
    await new API().get(`${URLS.cancelPayment}`)
    dispatch(getOpenPayments())
  } catch (error) {
    dispatch({ type: RESPONSE.SET_ERROR, error })
  }
}
